import React, { ComponentProps, ReactNode } from 'react';
import get from 'lodash/get';
import {
  FormInput,
  Label,
  IFormInputProps,
  CurrencyInputProps,
  CurrencyInput,
} from '@grubhubprod/gh-cookbook-react';
import { Control, RegisterOptions, useController } from 'react-hook-form';

interface CookbookCurrencyInputWrapperBaseProps {
  name: string;
  control: Control;
  rules?: RegisterOptions;
  error?: IFormInputProps['error'];
  label?: ReactNode;
}

export type CookbookCurrencyInputWrapperProps =
  CookbookCurrencyInputWrapperBaseProps & CurrencyInputProps;

export function CookbookCurrencyInputWrapper({
  name,
  control,
  rules = {},
  error,
  label = '',
  ...props
}: CookbookCurrencyInputWrapperProps): JSX.Element {
  const { field } = useController({
    name,
    rules,
    control,
    defaultValue: get(control.defaultValuesRef.current, name) ?? '',
  });

  return (
    <FormInput
      error={error}
      inputSize={props.inputSize}
      blockWidth={props.blockWidth}
    >
      {label && <Label htmlFor={props.id}>{label}</Label>}
      <CurrencyInput
        {...field}
        {...(props as ComponentProps<typeof CurrencyInput>)}
      />
    </FormInput>
  );
}
